import { IAISuggestion, IQuestionAnswer } from '@/components/staffer/Grading/types';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import { generatingSuggestionAnswers } from './aiSuggestion';

const STILL_LANDING: IAISuggestion['state'][] = ['generating', 'ai_suggested_pending'];

// AIDEV-NOTE: scoped like the page banner — the student's answers on Grade by Student, this question's
// answers on Grade by Question. While any answer in that scope is generating, finished ones keep
// showing "Suggesting score…" so every chip, stripe and the banner switch over together.
const useDisplayedSuggestion = (questionAnswer?: IQuestionAnswer): IAISuggestion | undefined => {
  const { isQuestionMode, questionAnswers } = useGradingStore();
  const suggestion = questionAnswer?.ai_suggestion;

  if (!suggestion) return undefined;

  const scopedAnswers = isQuestionMode
    ? questionAnswers?.filter(qa => qa.question_id.toString() === questionAnswer.question_id.toString())
    : questionAnswers;
  const batchStillRunning = generatingSuggestionAnswers(scopedAnswers).length > 0;

  if (batchStillRunning && STILL_LANDING.includes(suggestion.state)) return { ...suggestion, state: 'generating' };

  return suggestion;
};

export default useDisplayedSuggestion;
